module.exports = __webpack_public_path__ + "static/why-health.390c0384.jpg";